import config from '@app/config'
import { getTranslatedData } from '@app/helpers'
import { RegionalSettings } from '@app/models'
import { UserState } from '@app/store/user'
import { DEFAULT_LANGUAGE } from '@app/utils/regional'

export const getUnlockContactDetailsUrl = (
  userState: UserState,
  regionalSettings: RegionalSettings
): string => {
  const { currentUser, account } = userState
  const language = regionalSettings.language || DEFAULT_LANGUAGE
  const { countryISO } = regionalSettings
  const company = getTranslatedData(account?.name || [], language)

  const culture =
    countryISO && !language.includes('-')
      ? `${language}-${countryISO}`
      : language

  const { unlockContactDetailsUrls } = config

  const url =
    unlockContactDetailsUrls[culture] ||
    unlockContactDetailsUrls[language] ||
    unlockContactDetailsUrls[DEFAULT_LANGUAGE]

  const queryString = new URLSearchParams({
    email: currentUser.email,
    fullname: currentUser.fullName || '',
    phone: currentUser.phone || '',
    company,
    utm_medium: 'referrer',
    utm_source: 'messages',
    utm_campaign: 'conversation_contact_details',
  }).toString()

  return `${url}?${queryString}`
}
